import { DataType } from './DataType';
import { DataValue } from './DataValue';

export type FormFieldType =
    | 'text'
    | 'number'
    | 'email'
    | 'textarea'
    | 'select'
    | 'checkbox'
    | 'radio'
    | 'date'
    | 'url'
    | 'phone'
    | 'toggle'
    | 'slider'
    | 'rating';

export interface FormSeparator {
    id: string;
    type: 'separator';
    label?: string;
    [key: string]: DataValue | undefined;
}

export interface FormField {
    id: string;
    type: FormFieldType;
    label: string;
    placeholder?: string;
    optional: boolean;
    options?: string[];
    defaultValue?: string;
    validation?: {
        min?: number;
        max?: number;
        pattern?: string;
        minLength?: number;
        maxLength?: number;
    };
    [key: string]: DataValue | undefined;
}

export type FormElement = FormField | FormSeparator;

export function formFieldTypeToDataType(type: FormFieldType, options?: string[]): DataType {
    switch (type) {
        case 'number':
        case 'slider':
        case 'rating':
            return { kind: 'number' };
        case 'checkbox':
        case 'toggle':
            return { kind: 'boolean' };
        case 'select':
        case 'radio':
            if (options && options.length > 0) {
                return {
                    kind: 'union',
                    subTypes: options.map(option => ({ kind: 'stringLiteral' as const, stringLiteral: option })) as [
                        DataType,
                        ...DataType[],
                    ],
                };
            }
            return { kind: 'string' };
        default:
            return { kind: 'string' };
    }
}
